export const ModuleList = {
  modules: {
    userManagement: {
      name: 'User Management',
      sections: {
        userDetails: 'User Details',
        generalSettings: 'General Settings',
        aliases: 'Aliases',
        personalContacts: 'Personal Contacts',
        profileInformation: 'Profile Information',
        customAttributes: 'Custom Attributes',
        groups: 'Groups',
        accountDelegation: 'Account Delegation',
        filters: 'Filters',
        sendAs: 'Send As',
        labels: 'Labels',
        popSettings: 'POP Settings',
        imapSettings: 'IMAP Settings',
        vacationResponder: 'Vacation Responder',
        forwarding: 'Forwarding',
        forwardingAddresses: 'Forwarding Addresses',
        signatures: 'Signatures',
        calendars: 'Calendars',
        drive: 'Drive',
        driveSearch: 'Drive Search',
        auditing: 'Auditing',
        mobileDevices: 'Mobile Devices',
        appPasswords: 'App Passwords',
        thirdPartyApplications: 'Third Party Applications',
        history: 'History',
      },
    },
    directory: {
      name: 'Directory',
      sections: {
        gpanelContacts: 'GPanel Contacts',
        groups: 'Groups',
        groupTemplates: 'Group Templates',
        organizationalUnits: 'Organizational Units',
        sharedContacts: 'Shared Contacts',
        contactSync: 'Contact Sync',
      },
    },
    calendars: {
      name: 'Calendars',
      sections: {
        calendars: 'Calendars',
        resourceCalendars: 'Resource Calendars',
        resourceTemplates: 'Resource Templates',
        calendarTransferLogs: 'Calendar Transfer Logs',
        buildings: 'Buildings',
      },
    },
    drive: {
      name: 'Drive',
      sections: {
        driveExplorer: 'Drive Explorer',
        driveSearch: 'Drive Search',
        driveSweep: 'Drive Sweep',
        sharedDrives: 'Shared Drives',
        ownershipTransferLogs: 'Ownership Transfer Logs',
      },
    },
    automation: {
      name: 'Automation',
      sections: {
        rulesEngine: 'Rules Engine',
        policies: 'Policies',
        bulkOperations: 'Bulk Operations',
        signatureTemplates: 'Signature Templates',
        decommissioning: 'Decommissioning',
        decomSuspended: 'Decom Suspended Users',
        decomLogs: 'Decom Logs',
      },
    },
    devices: {
      name: 'Devices',
      sections: {
        mobileManagement: 'Mobile Management',
        chromeDevices: 'Chrome Devices',
      },
    },
    logging: {
      name: 'Logging',
      sections: {
        logging: 'Logging',
      },
    },
    reportCenter: {
      name: 'Report Center',
      sections: {
        reports: 'Reports',
        cPanelLogs: 'cPanel Logs',
      },
    },
    importExport: {
      name: 'Import/Export',
      sections: {
        bulkOperations: 'Bulk Operations',
        gmailExport: 'Gmail Export',
        vaultExport: 'Vault Export',
        gmailDeletion: 'Gmail Deletion',
      },
    },
    userView: {
      name: 'User View',
      sections: {
        profileInformation: 'Profile Information',
        customAttributes: 'Custom Attributes',
        myGroups: 'My Groups',
        allGroups: 'All Groups',
        groupDetails: 'Group Details',
        sharedContacts: 'Shared Contacts',
        directorySearch: 'Directory Search',
      },
    },
    administration: {
      name: 'Administration',
      sections: {
        api: 'API',
        settings: 'Settings',
        logs: 'Logs',
        roleManager: 'Role Manager',
        indexing: 'Indexing',
      },
    },
    gpanelView: {
      name: 'gPanel View',
      sections: {
        marketingManager: 'Marketing Manager',
      },
    },
    trialPeriod: {
      name: 'Trial Period',
      sections: {
        trialPeriod: 'TrialPeriod',
      },
    },
    billing: {
      name: 'Billing',
      sections: {
        billingInformation: 'Billing Information',
        billingContacts: 'Billing Contacts',
        subscriptions: 'Subscriptions',
        payments: 'Payments',
      },
    },
    commandDashboard: {
      name: 'Command Dashboard',
      sections: {
        tileManagement: 'Tile Management',
      },
    },
  },
};
